import type { Ord } from 'fp-ts/lib/Ord';

/**
 * Taken from fp-ts/lib/Ord, just wrapped into a getter function to be easily usable
 * for any subtype of orderable primitives
 */
const primitiveOrd: Ord<string | number | boolean> = {
  compare: (x, y) => (x < y ? -1 : x > y ? 1 : 0),
  equals: (a, b) => a === b,
};

export const getPrimitiveOrd = <
  T extends string | number | boolean,
>(): Ord<T> => primitiveOrd;
